var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basic-portlet',{attrs:{"title":"Login As User","icon":"la la-key"}},[_c('login-as-user')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }